import DOMPurify from 'isomorphic-dompurify';

/**
 * Sanitize HTML content while preserving certain tags like iframes
 * Used for user-generated content that may contain embeds
 */
export function sanitizeHtml(html: string): string {
	// Configure DOMPurify to allow iframes and their attributes
	const clean = DOMPurify.sanitize(html, {
		ADD_TAGS: ['iframe', 'center'],
		ADD_ATTR: [
			'frameborder',
			'allowfullscreen',
			'allow',
			'scrolling',
			'style',
			'width',
			'height',
			'src',
		],
		// Allow data URLs for images but not for iframes (security)
		ALLOW_DATA_ATTR: false,
		// Ensure iframe src URLs are from trusted domains
		ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
	});

	return clean;
}

/**
 * Sanitize HTML strictly - no iframes or potentially dangerous content
 * Used for more restricted contexts
 */
export function sanitizeHtmlStrict(html: string): string {
	return DOMPurify.sanitize(html);
}
